import { WeightMetric } from '../model/prefixed-unit/weight.metric';
import { getSuggestedUnit } from '../modules/diagram/components/tree-diagram/get-suggested-unit';
import { convertUnit } from './prefixed-unit/convert-unit';

export function getUnit(value: number): WeightMetric {
  //TODO: Adapt getSuggestedUnitToWork with a given metric or perhaps introduce a WeightValue which contains both unit and value for a weight. Remove this function
  return getSuggestedUnit(convertUnit(WeightMetric.Gram, WeightMetric.Tonne, value));
}
